export default "__VITE_ASSET__bKeZmVy6__"